import * as React from "react"
import * as ReactDom from "react-dom"
import App  from "../components/App"
import { animate } from "../components/animateComponents";
import Modal from "../components/modal";

import { checkTapit } from "../components/checkTapit";
// import "./App.css"

  
export const page = async () => {
	checkTapit()
	animate();
	new Modal('#shareModal')

	window.onload = function () { 
		let c2canvasdiv = document.querySelector('#c2canvasdiv') as any;
		let c2canvas = document.querySelector('#c2canvas') as any;
		let containerGame = document.querySelector('.container-game-doble-malta') as any;
		if(c2canvasdiv){
			containerGame.style.height = 'auto';
			c2canvas.style.border = '4px solid #CEAB52';
		}
	}
}